import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter  } from 'react-router-dom';
import PropTypes from "prop-types";
import { getNotifications, logNotificationsViewed, logNotificationOpened } from "../../redux/actions/userActions";
import UserAvatar from 'react-user-avatar';
import NotificationParser from './NotificationParser';
import * as apiConfig from "../../api/config";
import 'bootstrap/js/dist/collapse.js';
import moment from "moment";
import $ from 'jquery';
import { HubConnectionBuilder } from '@aspnet/signalr'

function UserStatus({
    auth,
    user,
    notifications,
    getNotifications,
    logNotificationsViewed,
    logNotificationOpened,
    history
}) {


    const [fetchingNotifications, setFetchingNotifications] = useState(true);
    const [connected, setConnected] = useState(false);

    useEffect(() => {
    }, [])

    useEffect(() => {
        console.log('Connection state changed');
        if (!connected) {
            console.log('Setting up notification hub connection...');
            if (user.id) {
                getNotifications().then(() => {
                    setFetchingNotifications(false);
                });

                var connection = new HubConnectionBuilder().withUrl("/notificationhub").build();

                connection.on("ReceiveNotification", function (notification) {
                    console.log("Notifications incoming!");
                    getNotifications();
                });

                connection.start().then(function () {
                    setConnected(true);
                    console.log("Started connection to notifcation hub.");
                }).catch(function (err) {
                    console.log('Connection failed...');
                    return console.error(err.toString());
                    setConnected(false);
                });
            }
        }
    }, [connected])

    function handleLogout(event) {
        event.preventDefault();
        history.push("/logout");
    }

    function onOpenNotifications(e) {
        e.preventDefault();
        logNotificationsViewed(); 
    }

    function onClickNotification(notification) {
        logNotificationOpened(notification.notificationId);
    }

    $(document).click(function (e) {
        var clickover = $(e.target);
        var opened = $(".notify-panel").hasClass("show");
        if (opened === true && !clickover.hasClass("notify-icon")) {
            $(".notify-panel").collapse('hide');
        }
        var openedProfile = $(".profile-panel").hasClass("show");
        if (openedProfile === true && !clickover.hasClass("user-status-container")) {
            $(".profile-panel").collapse('hide');
        }
    });

    function getBadgeIcon(notification) {
        var icon = ""; 
        switch (notification.feature) {
            case "UserNetwork":
                icon = "fas fa-user-friends"
                break;
            case "Groups":
                icon = "fas fa-users"
                break;
            case "Events":
                icon = "far fa-calendar-alt"
                break;
            case "Posts":
                icon = "fas fa-clock"
                break;
            case "Routes":
                icon = "fas fa-route"
                break;
        }
        return icon; 
    }

    function getLinkTo(notification) {
        if (notification.feature === "UserNetwork" && (notification.type === "Post"
            || notification.type === "NewFollower"
            || notification.type === "FollowRequested"
            || notification.type === "FollowApproved")) {
            return `/user/profile/${notification.subjectUser.userId}`;
        }
        if (notification.feature === "UserNetwork" && (notification.type === "Post" || notification.type === "Comment" || notification.type === "Reply" )) {
            return `/posts/${notification.subjectId}`;
        }
        return `/${notification.feature.toLowerCase()}/${notification.type == "Post" ? notification.parentSubjectId : notification.subjectId}`;
    }

    return (
        <div>
            {!user.id ?
            <React.Fragment>
                <Link className="user-status-logout btn btn-link btn-sm" to={"/login"}>
                    Log in
                </Link>
                <button className="btn btn-info btn-sm" onClick={()=> history.push("/signup")}>Sign Up</button>
            </React.Fragment>
            :
            <React.Fragment>
                <div className="dropdown float-right">
                    <div className="user-status-container" data-toggle="collapse" data-target="#profile-panel" aria-controls="profile-panel" aria-haspopup="true" aria-expanded="false">
                        {user.avatarAvailable ?
                            <UserAvatar className="user-status-avatar" size="28" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                            :
                            <div className="user-status-avatar user-avatar-default"><span className="fas fa-user" /></div>
                        }
                    </div>
                </div>
                <div className="profile-panel collapse" id="profile-panel">
                    <ul className="nav"> 
                        <li role="presentation" className="nav-item">        
                            <Link to="/user/profile" className="nav-link">
                                <span className="fas fa-user"></span> Profile
                            </Link>
                        </li>
                        <li role="presentation" className="nav-item">
                            <Link to="/user/settings/general" className="nav-link">
                                <span className="fas fa-cog"></span> Settings
                            </Link>
                        </li>
                        {user.isAdmin &&
                            <React.Fragment>
                                <hr />
                                <li role="presentation" className="nav-item">
                                    <Link to="/_adm/dashboard" className="nav-link">
                                        <span className="fas fa-user-shield"></span> Administration
                                    </Link>
                                </li>
                            </React.Fragment>
                        }
                        <hr />
                        <li role="presentation" className="nav-item">
                            <a className="nav-link" href="#" onClick={handleLogout}>
                                <span className="fas fa-sign-out-alt"></span> Log Out
                            </a>
                        </li>

                    </ul>
                </div>
                <div className="dropdown float-left">
                    <button className={notifications.latestNotification > notifications.lastViewed ? "notify-icon" : "notify-icon" } type="button" onClick={onOpenNotifications} data-toggle="collapse" data-target="#notifications" aria-controls="notifications" aria-haspopup="true" aria-expanded="false">
                        <span className="fas fa-bell" />
                    </button>
                    <div className={notifications.latestNotification > notifications.lastViewed ? "notification-indicator d-block" : "notification-indicator d-none"}></div>
                </div>
                <div className="notify-panel collapse" id="notifications">
                    <div className="">
                        <div className="notify-panel-title">Notifications</div>
                            { fetchingNotifications ?
                                <div className="notify-panel-zero-items">
                                    <div className="spinner-border spinner-border-sm mr-1" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    Loading...
                                </div>
                                :
                                notifications.items.length == 0 ?
                                    <div className="notify-panel-zero-items">
                                        Nothing to report!
                                    </div>
                                    :
                                    <ul className="">
                                        {
                                            notifications.items.map(notification => {
                                                return (
                                                    <li key={notification.notificationId} className={notification.seenOn == null ? "notify-panel-item unopened" : "notify-panel-item"} >
                                                        <Link to={{ pathname: getLinkTo(notification), state: { source: "notifications" } }} onClick={() => onClickNotification(notification)} value={notification}>
                                                            {(user.id && user.id.toUpperCase() == notification.subjectUser.userId.toUpperCase()) ?
                                                                <UserAvatar className="item-subject-avatar" size="40" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                                :
                                                                <UserAvatar className="item-subject-avatar" size="40" name={`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`} src={notification.subjectUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${notification.subjectUser.userId}.png` : ""} />
                                                            }
                                                            <div className={`notification-badge ${notification.feature.toLowerCase()}`}><span className={getBadgeIcon(notification)}></span></div>
                                                            <div className="item-message">
                                                                <NotificationParser notification={notification} />
                                                            </div>
                                                            <div className="item-footer">
                                                                {moment(notification.createdOn).fromNow()}
                                                            </div>
                                                        </Link>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                
                            }
                        <div className="notify-panel-footer"></div>
                    </div>
                </div>
            </React.Fragment>
            
            
            }

                
               
        </div>

    );


}

UserStatus.propTypes = {
    auth: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    notifications: PropTypes.object.isRequired,
    getNotifications: PropTypes.func.isRequired,
    logNotificationsViewed: PropTypes.func.isRequired,
    logNotificationOpened: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        user: state.user,
        notifications: state.notifications
    };
}

const mapDispatchToProps = {
    getNotifications,
    logNotificationsViewed,
    logNotificationOpened
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserStatus));


// WEBPACK FOOTER //
// ./src/components/user/UserStatus.js